export default "__VITE_ASSET__C8jFQv96__"